import logo from './components/images/hd_transparent_logo.png';
import * as React from "react";
import './App.css';
import "./services/firestore"
import { Footer } from "./components/Footer";
import { CLASS_DATA } from "./data/data";
import { Articles } from "./components/Article";
import { ClassInfo } from "./components/ClasInfo";
import { Contact } from "./components/Contact";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from "./components/Header";
import { ScrollBallerina } from "./components/ScrollBallerina";
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import { SingUp } from "./components/Sign-ups";
import { LoadingProvider } from './context/LoadingContext';
import { ScrollProvider } from './context/scrollContext';
import { Container, Navbar, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTiktok, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { useRef, useState, useEffect } from 'react';
import { SOCIAL_LINKS } from './utils/constants';

// Navigation Component
const NavigationBar = ({ refs }) => {
    const [scrolled, setScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 100;
            setScrolled(isScrolled);

            // Add active section detection
            const sections = ['nieuws', 'lessen', 'signup', 'contact'];
            const current = sections.find(section => {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    return rect.top <= 100 && rect.bottom >= 100;
                }
                return false;
            });
            setActiveSection(current || '');
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (ref) => {
        if (ref?.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Navbar 
            className={`navbar-modern fixed-top transition-all ${scrolled ? 'shadow-lg' : ''}`}
            expand="lg"
            style={{
                background: scrolled 
                    ? 'rgba(255, 255, 255, 0.95)' 
                    : 'linear-gradient(135deg, rgba(57, 10, 79, 0.9), rgba(40, 7, 55, 0.9))',
                backdropFilter: 'blur(15px)',
                borderBottom: scrolled ? '1px solid rgba(189, 161, 3, 0.3)' : 'none',
                padding: scrolled ? '0.5rem 0' : '1rem 0',
                transform: 'translateZ(0)', // Force hardware acceleration
            }}
        >
            <Container fluid className="px-4">
                <Navbar.Brand className="navbar-brand-modern">
                    <img
                        src={logo}
                        style={{ 
                            height: scrolled ? "4rem" : "5rem", 
                            width: scrolled ? "8rem" : "10rem",
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}
                        className="d-inline-block align-top"
                        alt="Dance at Beat Logo"
                    />
                </Navbar.Brand>
                
                <Navbar.Toggle 
                    aria-controls="basic-navbar-nav"
                    className="navbar-toggler"
                    style={{
                        borderColor: scrolled ? 'var(--primary-purple)' : 'white',
                        color: scrolled ? 'var(--primary-purple)' : 'white'
                    }}
                />
                
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link 
                            onClick={() => scrollToSection(refs.nieuwsRef)} 
                            className={`nav-link-modern nav-link-stagger-1 ${scrolled ? '' : 'text-light'} ${activeSection === 'nieuws' ? 'active' : ''}`}
                            style={{ animationDelay: '0.1s' }}
                        >
                            <i className="fas fa-newspaper"></i>
                            Nieuws
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => scrollToSection(refs.groepenRef)} 
                            className={`nav-link-modern nav-link-stagger-2 ${scrolled ? '' : 'text-light'} ${activeSection === 'lessen' ? 'active' : ''}`}
                            style={{ animationDelay: '0.2s' }}
                        >
                            <i className="fas fa-users"></i>
                            Lessen
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => scrollToSection(refs.inschrijvenRef)} 
                            className={`nav-link-modern nav-link-stagger-3 ${scrolled ? '' : 'text-light'} ${activeSection === 'signup' ? 'active' : ''}`}
                            style={{ animationDelay: '0.3s' }}
                        >
                            <i className="fas fa-user-plus"></i>
                            Inschrijven
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => scrollToSection(refs.contactRef)} 
                            className={`nav-link-modern nav-link-stagger-4 ${scrolled ? '' : 'text-light'} ${activeSection === 'contact' ? 'active' : ''}`}
                            style={{ animationDelay: '0.4s' }}
                        >
                            <i className="fas fa-envelope"></i>
                            Contact
                        </Nav.Link>
                    </Nav>
                    
                    <SocialMediaLinks scrolled={scrolled} />
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

// Social Media Links Component
const SocialMediaLinks = ({ scrolled }) => {
    return (
        <div className="social-links-modern">
            <a 
                href={SOCIAL_LINKS.FACEBOOK} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-modern"
                style={{
                    background: scrolled ? 'var(--primary-purple-light)' : 'rgba(255, 255, 255, 0.1)'
                }}
            >
                <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a 
                href={SOCIAL_LINKS.INSTAGRAM} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-modern"
                style={{
                    background: scrolled ? 'var(--primary-purple-light)' : 'rgba(255, 255, 255, 0.1)'
                }}
            >
                <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a 
                href={SOCIAL_LINKS.TIKTOK} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-modern"
                style={{
                    background: scrolled ? 'var(--primary-purple-light)' : 'rgba(255, 255, 255, 0.1)'
                }}
            >
                <FontAwesomeIcon icon={faTiktok} />
            </a>
        </div>
    );
};

// Section Separator Component
const SectionSeparator = ({ children }) => {
    return (
        <div className="d-flex align-items-center justify-content-center py-4" style={{ minHeight: '60px' }}>
            {children}
        </div>
    );
};

// Main Page Component
const MainPage = () => {
    const nieuwsRef = useRef();
    const groepenRef = useRef();
    const inschrijvenRef = useRef();
    const contactRef = useRef();

    const refs = { nieuwsRef, groepenRef, inschrijvenRef, contactRef };

    return (
        <LoadingProvider>
            <ScrollProvider>
                <NavigationBar refs={refs} />
                
                <div style={{ paddingTop: '80px' }}>
                    <Header />
                    
                    <SectionSeparator>
                        <div ref={nieuwsRef}></div>
                    </SectionSeparator>
                    <Articles />
                    
                    <SectionSeparator>
                        <div ref={groepenRef}></div>
                    </SectionSeparator>
                    <ClassInfo classesArray={CLASS_DATA} />
                    
                    <SectionSeparator>
                        <div ref={inschrijvenRef}></div>
                    </SectionSeparator>
                    <SingUp />
                    
                    <SectionSeparator>
                        <div ref={contactRef}></div>
                    </SectionSeparator>
                    <Contact />
                    
                    <Footer />
                    
                    {/* Scroll-triggered dancing ballerina */}
                    <ScrollBallerina />
                </div>
            </ScrollProvider>
        </LoadingProvider>
    );
};

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MainPage />} />
                {/* Add more routes here as needed */}
                <Route path="*" element={<MainPage />} />
            </Routes>
        </Router>
    );
}

export default App;
